/**
 * Phase 27.47 — flashAutofilled.
 *
 * Briefly highlight inputs that were just populated by Google Places
 * so the agent sees which fields the suggestion filled in. Idempotent
 * and safe to call for elements that may not exist (e.g. an optional
 * field wasn't in the parsed place).
 *
 * Usage inside an `onPlaceSelected` handler:
 *
 *   flashAutofilled(['retail-form-city', 'retail-form-state', 'retail-form-zip']);
 */
const FLASH_CLASS = 'gplaces-autofilled';
const FLASH_MS = 1200;

export function flashAutofilled(testIds) {
  if (!Array.isArray(testIds) || testIds.length === 0) return;
  // Delay by a microtask so React has a chance to render the freshly
  // populated value before we grab the DOM node.
  queueMicrotask(() => {
    testIds.forEach((id) => {
      if (!id) return;
      const el = document.querySelector(`[data-testid="${id}"]`);
      if (!el) return;
      // Remove first so a rapid second selection still animates.
      el.classList.remove(FLASH_CLASS);
      // Force reflow — otherwise re-adding the class in the same tick
      // does not restart the animation.
      void el.offsetWidth;
      el.classList.add(FLASH_CLASS);
      window.setTimeout(() => el.classList.remove(FLASH_CLASS), FLASH_MS);
    });
  });
}
